module.exports = __webpack_public_path__ + "static/map-usa-ef6af350ee3f4fe0fc2203952ed2b0d3.png";